import { deleteUrl } from '@/apiCalls/fetch';

export async function deleteDocument(id: string): Promise<void> {
    const url = `/api/documents/delete/${id}`;
    await deleteUrl(url);
    return;
}
